import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { ActionHandlerFunction, UserProfile } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  users: UserProfile[];
  handleAction: ActionHandlerFunction;
}

// Description: Details card component for the cloud lock settings page 
// displayed when the admin adds more users to the cloud lock exception list
function DetailsCardComponent(props: AllProps) {
  const { users, handleAction } = props;

  return <div className="table-display mt-3">
    <Row className="header-card-row">
      <Col xs={5}>Approver</Col>
      <Col xs={5}>Role</Col>
    </Row>
    <div className="table-body">
      {_.map(users, (_user: UserProfile, index: number) => {
        const { name, address, role} = _user;
        return <Row key={index}>
          <Col xs={5}>
            <p className="semi-bold">{name}</p>
            <p>{address.toLowerCase()}</p>
          </Col>
          <Col xs={5}>
            <p className="m-0">{_.capitalize(role)}</p>
          </Col>
          <Col xs={1} className="ms-auto">
            <Button
              variant="icon"
              size="sm"
              title="Delete User Group"
              data-tooltip-id="pv-tooltip"
              data-tooltip-content="Delete User Group"
              onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete, params: [_user.address] })}>
              <Icon className="ficon-x" />
            </Button>
          </Col>
        </Row>;
      })}
    </div>
  </div>;
}

export default React.memo(DetailsCardComponent);